import {UserActivityType} from "../../model/User";
import {DateUtils} from "../../common/Utils";
import {Fragment} from "react";
import {Route} from "../../model/Wall";

export default function ActivityCard({activity, onActivityClick}) {
    const timeString = activity.timestamp.toLocaleTimeString("en-US", {
        hour: "2-digit", minute: "2-digit", hour12: false
    });
    const routeColor = Route.getColorHexString(activity.route);

    function getActivityName(activityType) {
        switch (activityType) {
            case UserActivityType.Attempt:
                return "Attempted";
            case UserActivityType.Climb:
                return "Climbed";
            case UserActivityType.Flash:
                return "Flashed";
            default:
                throw new Error();
        }
    }

    function getActivityColor(activityType) {
        switch (activityType) {
            case UserActivityType.Attempt:
                return "bg-green-700";
            case UserActivityType.Climb:
                return "bg-orange-700";
            case UserActivityType.Flash:
                return "bg-red-700";
            default:
                throw new Error();
        }
    }

    return (
        <div className="py-0.5 pr-4">
            <div
                className="relative p-2 rounded my-0.5 ml-2 border bg-gray-700 cursor-pointer"
                onClick={() => onActivityClick(activity)}
            >
                <div className={`${getActivityColor(activity.type)} w-fit px-2.5 py-0.5 mb-1 rounded`}>
                    {getActivityName(activity.type)}
                </div>
                <div className="flex justify-left space-x-2">
                    <span className="mr-2">{activity.route.name}</span>
                    {routeColor &&
                        <div
                            className="h-5 w-5 rounded-full"
                            style={{backgroundColor: routeColor}}
                        ></div>
                    }
                    <span>{activity.route.difficulty ?? ""}</span>
                </div>
                <div className="absolute top-2 right-3 italic">{timeString}</div>
            </div>
        </div>);
}